import React from "react";
import { ColumnValueRendererProps, LocationColumnValue } from "../table.data.interface";
import { Tooltip } from "@vibe/core";

const LocationColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  if (columnData.value === "Empty Column" || (!columnData?.value && otherBoardsValues)) {
    return null;
  }

  const value = otherBoardsValues
    ? (columnData?.value as LocationColumnValue)?.address
    : isPreview
      ? columnData?.text
      : (columnData?.value as string);

  if (isPreview) {
    return (
      <div className="overflow-hidden whitespace-nowrap text-ellipsis">
        <Tooltip content={value}>
          <span>{value as string}</span>
        </Tooltip>
      </div>
    );
  }

  return <div>{value}</div>;
};

export default LocationColumn;
